import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type InitialStateType = Partial<User> & {
  isAuth: boolean
}

const initialState: InitialStateType = {
  isAuth: false,
  confirmed: false,
}

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      Object.entries(action.payload).forEach(([key, value]) => {
        // @ts-ignore
        state[key] = value
      })
      state.isAuth = true
    },
    updateUserInfo: (state, action: PayloadAction<Partial<User>>) => {
      Object.entries(action.payload).forEach(([key, value]) => {
        // @ts-ignore
        state[key] = value
      })
    },
    logout: () => initialState,
  },
})

export const profileActions = profileSlice.actions
export const profileReducer = profileSlice.reducer
